module.exports = __webpack_public_path__ + "img/no-apps-activity.3c4da303.webp";